<div class="w-full container_width">
  <div class="w-full flex flex-column gap-3">

    <div
      class="flex w-full align-items-start gap-2 sm:align-items-center flex-column sm:flex-row justify-content-between">
      <h1 class="text-left text-3xl font-medium">Edit / Manage Colleges</h1>
      <p-button icon="pi pi-user-plus" (click)="addCollege()" label="Add College"
        class="w-full sm:w-auto flex sm:inline-flex flex-column gap-1" styleClass="submitBtn" />
    </div>
    <div class="w-full flex flex-column gap-3">
      <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
        <h2 class="text-left text-xl font-medium px-2" style="color: #101011;">Search</h2>
        <div class="w-full flex flex-wrap">
          <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-2">
            <b class="text-left font-normal text-base" style="color: #424242;">Select Country</b>
            <p-dropdown [options]="countries" styleClass="selectFull" class="w-full" optionLabel="name"
              optionValue="name" [(ngModel)]="selectedCountry" [filter]="true" filterBy="name" [showClear]="true"
              appendTo="body" placeholder="Select a Country">
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <div>{{ selectedOption.name }}</div>
                </div>
              </ng-template>
              <ng-template let-country pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ country.name }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>

          <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-2">
            <b class="text-left font-normal text-base" style="color: #424242;">College</b>
            <p-autoComplete [suggestions]="searchAutoCompleteInstitutes" [(ngModel)]="collegeName"
              (completeMethod)="filterInstitutes($event)" optionLabel="name" placeholder="Search a college"
              styleClass="fullWidth" class="w-full block" />
          </div>

          <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column justify-content-end">
            <!-- <p-button label="Search" [loading]="isLoading" [disabled]="!selectedCountry" class="w-full"
              styleClass="buttonFull" (onClick)="searchInstitutes(1)" /> -->
            <p-button label="Search" [loading]="isLoading" [disabled]="!selectedCountry && !collegeName" class="w-full"
              styleClass="buttonFull" (onClick)="searchInstitutes(1)" />
          </div>
        </div>
      </div>
      <div class="w-full">
        <p-table *ngIf="institutes && institutes.length > 0; else noRecordsFound" [value]="institutes"
          [lazyLoadOnInit]="false" [paginator]="institutes.length!=total" [rows]="rowSize" [totalRecords]="total"
          [first]="first" [lazy]="true" (onLazyLoad)="onLazyLoad($event)" [rowsPerPageOptions]="[10, 20, 30]"
          [showPageLinks]="true" styleClass="p-datatable-gridlines tableCon" [tableStyle]="{ 'min-width': '50rem' }">
          <ng-template pTemplate="header">
            <tr>
              <th>Name</th>
              <th>Country </th>
              <th>City</th>
              <th>Branch Campuses</th>
              <th>QS ranking</th>
              <th>Actions</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-institute>
            <tr>
              <td>{{ institute.name }}</td>
              <td>{{ institute.countryName }}</td>
              <td>{{ institute.cityName }}</td>
              <td>{{ institute.branchCampuses }}</td>
              <td>{{ institute.qsRanking }}</td>
              <!-- <td>
                {{ institute.currency === 'Dollar' ? 'USD ' + institute.tutionFees : (institute.currency || '') + ' ' +
                (institute.tutionFees || 0) }}
              </td> -->
              <td>
                <div class="w-auto inline-flex justify-content-center gap-1">
                  <p-button pTooltip="Edit Profile" tooltipPosition="top" icon="pi pi-file-edit"
                    styleClass="edit_profile" (onClick)="editCollege(institute.id)"></p-button>
                  <!-- <p-button pTooltip="Manage Essay Pilot" tooltipPosition="top"
                    [loading]="isEssayPilotLoader && institute.id==selectedInstitute?.id" icon="pi pi-sliders-v"
                    styleClass="m_essay_p" (onClick)="showDialog(institute,action.EssayQuestions)"></p-button> -->
                  <p-button pTooltip="Checklist" tooltipPosition="top"
                    [loading]="isCheckListLoader && institute.id==selectedInstitute?.id" icon="pi pi-list-check"
                    styleClass="checklist" (onClick)="showDialog(institute,action.AddCheckList)"></p-button>
                  <p-button pTooltip="Agents" tooltipPosition="top"
                    [loading]="isEssayPilotLoader && institute.id==selectedInstitute?.id" icon="pi pi-user-edit"
                    styleClass="m_essay_p" (onClick)="showDialog(institute,action.Agents)"></p-button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <ng-template #noRecordsFound>
          <div class="w-full flex flex-column align-items-center py-4 gap-5">
            <div class="w-full flex align-items-center justify-content-center">
              <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
            </div>
            <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <p-dialog *ngIf="currentAction"
    [header]="currentAction === action.AddCheckList ? 'Manage Check list' : (currentAction === action.Agents ? 'Manage Agents' : 'Manage Essay Pilot')"
    [modal]="true" [(visible)]="visible" [style]="{ width: '50rem' }"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" (onHide)="closeDialog()">
    <app-set-check-list *ngIf="currentAction=== action.AddCheckList" [checkList]="this.checkList"
      [institute]="selectedInstitute" (closeDialog)="closeDialog()"></app-set-check-list>
    <app-add-institute-questions *ngIf="currentAction===action.EssayQuestions" [institute]="selectedInstitute"
      [essayQuestion]="essayQuestions" (closeDialog)="closeDialog()" [visible]="visible"></app-add-institute-questions>
    <app-manage-agents *ngIf="currentAction===action.Agents" [institute]="selectedInstitute"
      (closeDialog)="closeDialog()" [visible]="visible"></app-manage-agents>
  </p-dialog>